import AmexGDAB2BDinerExperience from './AmexGDAB2BDinerExperience';

export default AmexGDAB2BDinerExperience;
